import { render } from "./TokenExpired.vue?vue&type=template&id=8225337a"
import script from "./TokenExpired.vue?vue&type=script&lang=js"
export * from "./TokenExpired.vue?vue&type=script&lang=js"
script.render = render

export default script